<template>
  <!-- 供应商管理新增/修改 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="50%"
    @ok="handleOk"
    @cancel="close"
  >
    <div class="projectManageModal">
      <a-form-model
        ref="formRef"
        :model="dataValue"
        labelAlign="right"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="rules"
      >
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="供应商名称"
              prop="companyName"
              :labelCol="rowLabel"
              :wrapperCol="rowWrapper"
            >
              <a-input v-model="dataValue.companyName" placeholder="请输入供应商名称" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="title === `[修改]-${this.$tree([], 'purchase/supplier/index')}`">
          <a-col :span="24">
            <a-form-model-item label="下属联系人">
              <span>{{dataValue.customerName}}</span>
              <a-button
                type="primary"
                size="small"
                @click="addLinkNameClick"
                style="margin-left: 20px;"
              >添加联系人</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="title === `[新建]-${this.$tree([], 'purchase/supplier/index')}`">
          <a-col :span="12">
            <a-form-model-item label="姓名">
              <a-input v-model="dataValue.name" placeholder="请输入姓名" style="width: 100%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="手机">
              <a-input
                v-model="dataValue.phone"
                type="tel"
                :max-length="11"
                placeholder="请输入手机号码"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="title===`[新建]-${this.$tree([], 'purchase/supplier/index')}`">
          <a-col :span="12">
            <a-form-model-item label="部门" prop="dept">
              <a-input v-model="dataValue.linkmanDept" placeholder="请输入部门" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="职务" prop="linkmanDuty">
              <a-input v-model="dataValue.linkmanDuty" placeholder="请输入职务" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="种类" prop="customerType">
              <a-select v-model="dataValue.customerType" placeholder="请选择供应商种类">
                <a-select-option
                  v-for="item in customerType"
                  :key="item.label"
                  :value="item.label"
                  style="width: 100%;"
                >{{item.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="收款人名称">
              <a-input v-model="dataValue.payeeName" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="银行帐号">
              <a-input v-model="dataValue.bankAccount" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="银行名称">
              <a-input v-model="dataValue.bankName" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="行号">
              <a-input v-model="dataValue.bankCode" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="付款信息" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <a-textarea :rows="4" placeholder="请输入付款信息" v-model="dataValue.payInfo" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="上传附件" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <upload-attachment ref="uploadRef" :val-name="valName" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <link-add-vue
      ref="linkNameRef"
      :title="`[新建]-${this.$tree([], 'purchase/supplier/supplierLink/index')}`"
      :dialog-visible="linkNameVisible"
      @success="linkAddSucc"
      @close="linkAddClose"
    />
    <template #footer>
      <a-button @click="close" style="background-color:#F2F2F2">取消</a-button>
      <a-button type="primary" :loading="loading" @click="handleOk">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment'
import uploadAttachment from '../../common/Upload.vue'
import linkAddVue from './supplierLink/addEdit.vue'

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

export default {
  name: 'Addedit',
  components: { uploadAttachment, linkAddVue },
  provide () {
    return {
      formData: this
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    dictData: {
      type: Object,
      default: () => {
      }
    },
    timeProcessings: {
      type: String,
      default: ''
    },
    customerType: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      action: `https://www.mocky.io/v2/5cc8019d300000980a055e76`,
      dataValue: {
        customerCode: this.timeProcessings,
        name: '',
        customerType: '',
        phone: '',
        type: 2,
        createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        creator: this.owners()
      },
      loading: false,
      uploadFileList: [],
      valName: 'uploadFileList',
      suppliersTypes: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      rules: {
        companyName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        customerType: [{ required: true, message: '请选择种类', trigger: 'change' }]
        // phone: [
        //   {required: true, message: '请输入手机号码', trigger: 'blur'},
        //   {
        //     pattern: /^1[3456789]\d{9}$/,
        //     message: '请输入正确的手机号码',
        //     trigger: 'blur'
        //   }
        // ],
      },
      fileList: [],
      previewVisible: false,
      previewImage: '',
      linkNameVisible: false
    }
  },
  created () {
    this.owners()
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    }
  },
  watch: {
    timeProcessings (newVal, oldVal) {
      this.dataValue.customerCode = newVal
    }
  },
  methods: {
    moment,
    addLinkNameClick () {
      this.linkNameVisible = true
      this.$nextTick(() => {
        this.$refs.linkNameRef.setCustomer(this.dataValue)
      })
    },
    linkAddSucc (val) {
      this.linkNameVisible = false
      if (this.dataValue.customerName) {
        this.dataValue.customerName += `、${val.linkmanName}(${val.linkmanTel === null || val.linkmanTel === undefined ? '暂无电话' : val.linkmanTel})`
      } else {
        this.dataValue.customerName = `${val.linkmanName}(${val.linkmanTel === null || val.linkmanTel === undefined ? '暂无电话' : val.linkmanTel})`
      }
    },
    linkAddClose () {
      this.linkNameVisible = false
    },
    initData (row) {
      this.dataValue = row
      // 是否有下属联系人
      if (this.dataValue.linkmanList !== [] && this.dataValue.linkmanList.length > 0) {
        let linkList = this.dataValue.linkmanList
        let str = ''
        for (let k = 0; k < linkList.length; k++) {
          if (k !== linkList.length - 1) {
            str = str + `${linkList[k].linkmanName}(${linkList[k].linkmanTel === null ? '暂无电话' : linkList[k].linkmanTel})、`
          } else {
            str = str + `${linkList[k].linkmanName}(${linkList[k].linkmanTel === null ? '暂无电话' : linkList[k].linkmanTel})`
          }
        }
        this.dataValue.customerName = str
      }
      if (this.dataValue.fileIds) {
        // string 转 数组  循环获取附件信息
        let fileList = this.dataValue.fileIds.split(',')
        this.$nextTick(() => {
          this.$refs.uploadRef.getFile(fileList)
        })
      }
    },
    handleOk () {
      this.$refs.formRef.validate(valid => {
        if (this.$refs.uploadRef.setCount !== 0) {
          this.dataValue.fileIds = this.uploadFileList
        }
        if (valid) {
          this.loading = true
          if (this.title === `[新建]-${this.$tree([], 'purchase/supplier/index')}`) {
            this.$post('/customer/add', this.dataValue).then(res => {
              if (res.status === 200 && res.data.status === 1) {
                this.$message.success(res.data.message)
                // 联系人信息
                const linkObj = {
                  customerId: res.data.data.id,
                  linkmanName: this.dataValue.name,
                  linkmanDuty: this.dataValue.linkmanDuty,
                  linkmanTel: this.dataValue.phone,
                  linkmanDept: this.dataValue.linkmanDept,
                  customerType: 2
                }
                this.addLink(linkObj)
              } else {
                this.$message.error(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          } else {
            this.$post('/customer/update', this.dataValue).then(res => {
              if (res.status === 200 && res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.error(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          }
        }
      })
      this.$emit('update:dialogVisible', false)
    },
    addLink (linkForm) { // 添加联系人
      if (linkForm.linkmanName || linkForm.linkmanDuty || linkForm.linkmanTel || linkForm.linkmanDept) {
        this.$post('/linkman/add', linkForm).then(res => {
          if (res.data.status === 1) {
            this.$message.success(res.data.message)
            this.$emit('success')
            this.loading = false
            this.resetForm()
          } else {
            this.$message.warning(res.data.message)
          }
        })
      } else {
        // 调用完接口后再刷新首页数据
        this.$emit('success')
        this.resetForm()
      }
    },
    resetForm () {
      this.uploadFileList = []
      setTimeout(() => {
        this.dataValue = {
          customerCode: this.timeProcessings,
          type: 2,
          createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          creator: this.owners()
        }
      }, 500)
    },
    owners () {
      let own = localStorage.getItem('USER')
      return JSON.parse(own).username
    },
    close () {
      this.resetForm()
      this.$emit('close')
    },
    handleCancel () {
      this.previewVisible = false
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange ({ fileList }) {
      this.fileList = fileList
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-calendar-picker {
  width: 100%;
}

/deep/ .ant-form-item {
  display: flex;

  .ant-form-item-label {
    width: 90px;
  }

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/supplier/addEdit.vue